import api, { adminApiPrefix } from './Api';
import {
  Category,
  categoryFromResponse,
  categoryToUpsertRequest,
} from '../interfaces/Category/Category';
import { CategoryMediaOptions } from '../interfaces/Category/CategoryMediaOptions';

const categoryAdminApiPrefix = `${adminApiPrefix}/categories`;

export const createCategory = async (category: Category): Promise<Category> => {
  const response = await api.post(
    categoryAdminApiPrefix,
    categoryToUpsertRequest(category),
  );

  return categoryFromResponse(response.data?.data);
};

export const getCategories = async (): Promise<Category[]> => {
  const response = await api.get(categoryAdminApiPrefix);

  return (response.data?.data ?? []).map((category: any) =>
    categoryFromResponse(category),
  );
};

export const updateCategory = async (category: Category): Promise<Category> => {
  const response = await api.put(
    `${categoryAdminApiPrefix}/${category.id}`,
    categoryToUpsertRequest(category),
  );

  return categoryFromResponse(response.data?.data);
};

export const updateCategoryMedia = async (
  id: number,
  options: CategoryMediaOptions,
): Promise<Category> => {
  const bodyFormData = new FormData();

  if (options.logo) {
    bodyFormData.append('logo', options.logo);
  }

  if (options.banner) {
    bodyFormData.append('banner', options.banner);
  }

  if (options.eraseLogo) {
    bodyFormData.append('erase-logo', '1');
  }

  if (options.eraseBanner) {
    bodyFormData.append('erase-banner', '1');
  }

  const response = await api.put(
    `${categoryAdminApiPrefix}/media/${id}`,
    bodyFormData,
  );

  return categoryFromResponse(response.data?.data);
};

export const deleteCategory = async (id: number): Promise<void> =>
  api.delete(`${categoryAdminApiPrefix}/${id}`);
